import { Injectable } from "@angular/core";
import { Constant } from '../constants/constant';
import { ApiService } from './api.service';
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class ReportService {
    constructor(
        private http_client: ApiService,
        private router: Router,
    ) { }

    async printBondReport(params: any): Promise<any> {
        try {
            const response = await this.http_client.postData(Constant.new_base_url
                + `api/PreviewReports/bondreport`, params);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log("errorrorroror", error);
            return error;
        }
    }
    async printAnniversaryReport(params: any): Promise<any> {
        try {
            const response = await this.http_client.postData(Constant.new_base_url
                + `api/PreviewReports/anniversaryreport`, params);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log("errorrorroror", error);
            return error;
        }
    }
    async printCollateralReport(params: any): Promise<any> {
        try {
            const response = await this.http_client.postData(Constant.new_base_url
                + `api/PreviewReports/collateralreport`, params);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log("errorrorroror", error);
            return error;
        }
    }
    async printBondExecutionReport(params: any): Promise<any> {
        try {
            const response = await this.http_client.postData(Constant.new_base_url
                + `api/PreviewReports/executedbondreport`, params);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log("errorrorroror", error);
            return error;
        }
    }
}